import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, setBlockTracking as _setBlockTracking } from "vue";
const _hoisted_1 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" };
const _hoisted_2 = { class: "flex flex-col justify-end" };
const _hoisted_3 = { class: "card" };
const _hoisted_4 = { class: "px-3 lg:px-4 pt-3 pb-2" };
const _hoisted_5 = { class: "font-semibold" };
const _hoisted_6 = { class: "px-3 lg:px-4 pt-2 pb-3" };
const _hoisted_7 = { class: "flex flex-col justify-end" };
const _hoisted_8 = { class: "card" };
const _hoisted_9 = { class: "px-3 lg:px-4 pt-3 pb-2" };
const _hoisted_10 = { class: "font-semibold" };
const _hoisted_11 = { class: "divide-y divide-(--default-border-color) border-t border-(--default-border-color) list-unstyled" };
const _hoisted_12 = { class: "flex" };
const _hoisted_13 = { class: "px-3 lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_14 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_15 = ["textContent"];
const _hoisted_16 = { class: "flex" };
const _hoisted_17 = { class: "px-3 lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_18 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_19 = { key: 0 };
const _hoisted_20 = ["textContent"];
const _hoisted_21 = { key: 2 };
const _hoisted_22 = { class: "flex" };
const _hoisted_23 = { class: "px-3 lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_24 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_25 = ["textContent"];
const _hoisted_26 = { class: "flex" };
const _hoisted_27 = { class: "px-3 lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_28 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_29 = ["textContent"];
const _hoisted_30 = { class: "flex" };
const _hoisted_31 = {
    key: 0,
    class: "px-3 lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12"
};
const _hoisted_32 = {
    key: 1,
    class: "px-3 lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12"
};
const _hoisted_33 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_34 = ["textContent"];
const _hoisted_35 = {
    key: 0,
    class: "text-sm px-3 lg:px-4 pt-2 pb-3"
};
const _hoisted_36 = { class: "font-semibold" };
const _hoisted_37 = ["href"];
const _hoisted_38 = { class: "card print:shadow-none break-inside-avoid" };
const _hoisted_39 = { class: "px-3 lg:px-4 pt-3 pb-2" };
const _hoisted_40 = { class: "font-semibold" };
const _hoisted_41 = { class: "w-full relative aspect-4/3 sm:aspect-video lg:aspect-21/9" };
const _hoisted_42 = {
    key: 0,
    class: "absolute inset-0 flex justify-center items-center text-muted z-2",
    style: { "z-index": "2" }
};
import { computed, nextTick, ref, watch } from 'vue';
import { secToHhmmss, secToDatapointMs } from '@ts/common/time';
import { useDeferredChart } from '@ts/common/useDeferredChart';
import {} from '@ts/common/chart';
import { ___, toFixedNumberStrWithFallback } from '@ts/common/language';
import { closest } from '@ts/common/math';
import { kcalToG } from '@ts/common/nutrition';
import SvgVue from '@ts/components/utils/SvgVue.vue';
import LabeledSelect from '@ts/components/form/inputs/LabeledSelect.vue';
import LabeledSlider from '@ts/components/form/inputs/LabeledSlider.vue';
import {} from '@ts/components/form/types';
import Chart from 'chart.js/auto';
import {} from 'chart.js/auto';
import annotationPlugin from 'chartjs-plugin-annotation';
import 'chartjs-adapter-date-fns';
import {} from '@ts/common/datasets';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CarbohydrateManager',
    props: {
        data: { default: undefined },
        hint: { type: Boolean, default: true },
        formDisabled: { type: Boolean, default: false },
        forceCarboAvailability: { default: 'normal' },
        forcePower: { default: undefined },
        forceCarboIntakeTotal: { default: undefined }
    },
    setup(__props) {
        Chart.register(annotationPlugin);
        const props = __props;
        let chartObj = undefined;
        const chart = ref(null);
        const containerRef = ref(null);
        const showPlaceholder = ref(true);
        const carboAvailabilityOptions = {
            high: ___({ en: 'High availability (e.g. Carboloading)', de: 'Sehr gute Verfügbarkeit (z.B. Carboloading) ' }),
            normal: ___({ en: 'Normal availability (e.g. everyday life)', de: 'Normale Verfügbarkeit (z.B. Trainings-Alltag) ' }),
            low: ___({ en: 'Low availability (e.g. low carb training)', de: 'Geringe Verfügbarkeit (z.B. Low-Carb-Training) ' }),
        };
        const emptyCarboAvailabilityOption = { label: ___({ en: 'Select carbohydrate availability', de: 'Kohlenhydrat-Verfügbarkeit wählen' }), disabled: true, hidden: true };
        const carboAvailability = ref(props.forceCarboAvailability);
        const carboIntakeTotal = ref(80);
        const power = ref(210);
        const carboLimitMin = computed(() => {
            return props.data === undefined ? 100 : (Math.round(props.data.threshold_abs * 0.5) ?? 100);
        });
        const carboLimitMax = computed(() => {
            return props.data === undefined ? 350 : (Math.round(props.data.threshold_abs) ?? 350);
        });
        const carboData = ref(undefined);
        // Create the chart only once its container has a real (non-zero) size, then force a repaint —
        // Firefox otherwise draws into a 0-size/uncomposited canvas (blank until interaction, and never
        // recovers when the card starts off-screen). See useDeferredChart.
        useDeferredChart(containerRef, {
            create: () => {
                if (props.data !== undefined)
                    setData(props.data);
            },
            getChart: () => chartObj,
        });
        watch(() => props.data, (newValue, oldValue) => {
            if (newValue === undefined)
                return;
            setData(newValue);
        }, { deep: true });
        // Set while setData() reassigns the input refs from a new analysis payload, so the
        // consolidated watcher below doesn't recompute+redraw again (setData does that itself).
        // Reset via nextTick — the two writes are batched into a single watcher firing, and a
        // no-op write wouldn't fire it at all, which would otherwise leave the flag stuck.
        let suppressInputWatch = false;
        watch(() => [carboAvailability.value, carboIntakeTotal.value, power.value], () => {
            if (suppressInputWatch)
                return;
            onInputChanged();
        });
        function onInputChanged() {
            if (props.data === undefined)
                return;
            carboData.value = computeCarboData(props.data);
            if (carboData.value)
                drawChart(carboData.value);
        }
        function setData(data) {
            const referenceGroupId = data.reference_group_id;
            const referenceGroup = data.reference_groups[referenceGroupId];
            suppressInputWatch = true;
            carboIntakeTotal.value = typeof props.forceCarboIntakeTotal === 'undefined' ? referenceGroup.chIntakePerKgPerH * data.weight : props.forceCarboIntakeTotal;
            // carboIntakeInput.value?.setValue(Math.round(carboIntakeTotal.value));
            power.value = typeof props.forcePower === 'undefined' ? Math.round(data.fatmax_abs + (3 * (data.threshold_abs - data.fatmax_abs)) / 4) : props.forcePower;
            // powerInput.value?.setValue(power.value);
            nextTick(() => {
                suppressInputWatch = false;
            });
            carboData.value = computeCarboData(data);
            if (carboData.value)
                drawChart(carboData.value);
        }
        function computeCarboData(data) {
            let ffm = 0;
            if (data.bodyfat != null) {
                ffm = data.bodyfat;
            }
            else {
                if (data.gender == 'female') {
                    if (data.vo2max_rel > 60.0) {
                        ffm = 14.0;
                    }
                    else if (data.vo2max_rel > 50.0) {
                        ffm = 17.0;
                    }
                    else {
                        ffm = 20.0;
                    }
                }
                else {
                    if (data.vo2max_rel > 70.0) {
                        ffm = 12.0;
                    }
                    else if (data.vo2max_rel > 60.0) {
                        ffm = 15.0;
                    }
                    else {
                        ffm = 18.0;
                    }
                }
            }
            ffm = ((100.0 - ffm) / 100.0) * data.weight;
            let massRelMuscles = 0;
            if (ffm < 79) {
                massRelMuscles = ffm * 0.261 + 1.888;
            }
            else {
                massRelMuscles = ffm * 0.088 + 15.57;
            }
            const v02maxby10 = data.vo2max_rel / 10.0;
            let kcalMuscles = 0.0;
            if (carboAvailability.value == 'high') {
                kcalMuscles = massRelMuscles * (21.031 * v02maxby10 - 12.425);
            }
            else if (carboAvailability.value == 'low') {
                kcalMuscles = massRelMuscles * (5.0922 * v02maxby10 + 11.882);
            }
            else {
                kcalMuscles = massRelMuscles * (11.373 * v02maxby10 + 21.896);
            }
            const kcalProtected = massRelMuscles * 20.0;
            const carboInitInGrams = kcalToG(kcalMuscles, 'carb');
            const carboProtectedInGrams = kcalToG(kcalProtected, 'carb');
            const keyChartMetabolism = closest(power.value, data.chart_metabolism.power);
            const kcalCarboPerHour = keyChartMetabolism > 0 && keyChartMetabolism < data.chart_metabolism.energy_carbo_per_hour.length - 1 ? data.chart_metabolism.energy_carbo_per_hour[keyChartMetabolism] : undefined;
            const kcalFatPerHour = keyChartMetabolism > 0 && keyChartMetabolism < data.chart_metabolism.energy_fat_per_hour.length - 1 ? data.chart_metabolism.energy_fat_per_hour[keyChartMetabolism] : undefined;
            if (kcalCarboPerHour === undefined)
                return undefined;
            if (kcalFatPerHour === undefined)
                return undefined;
            const carboDemand = Math.round(10 * kcalToG(kcalCarboPerHour, 'carb')) / 10;
            const carboDeficit = Math.round(10 * (carboDemand - carboIntakeTotal.value)) / 10;
            const carboData = {
                carboInit: carboInitInGrams,
                carboProtected: carboProtectedInGrams,
                carboAvailable: Math.round(10 * (carboInitInGrams - carboProtectedInGrams)) / 10,
                carboAvailableTime: secToHhmmss((3600 * (carboInitInGrams - carboProtectedInGrams)) / carboDeficit, /* floorSeconds */ false, /* padHours */ true),
                carboIntake: Math.round((carboIntakeTotal.value / data.weight) * 100) / 100,
                carboDemand: carboDemand,
                carboDeficit: carboDeficit,
                carboDeficitAbs: Math.abs(carboDeficit),
                time: [],
                carboEnergy: [],
                totalEnergy: [],
            };
            let totalEnergy = 0;
            let carboEnergy = carboInitInGrams;
            // let mm = 0;
            // const mmIncrement = 5;
            // let h = 0;
            // const kcalPerWh = 0.85984522785899;
            let time = 0;
            const timeIncrement = 60 * 5;
            const maxTime = 6 * 3600;
            const frac = timeIncrement / 3600;
            let carboAtProtected = 0;
            // let i = 0;
            // time steps
            // while (carboAtProtected > -6 && i <= 12 * (60 / mmIncrement)) {
            while (carboAtProtected > -6 && time <= maxTime) {
                // carboData.time.push((h * 60 + mm) * 60 * 1000);
                carboData.time.push(secToDatapointMs(time));
                // carboData.time.push(secToDatapointMs((h * 60 + mm) * 60));
                carboData.carboEnergy.push(carboEnergy);
                if (carboAtProtected > -2)
                    carboData.totalEnergy.push(totalEnergy);
                time += timeIncrement;
                // mm += mmIncrement;
                // if (mm >= 60) {
                //   h += 1;
                //   mm = 0;
                // }
                // carboEnergy -= (1 / 12) * carboDeficit;
                carboEnergy -= frac * carboDeficit;
                if (carboEnergy > carboInitInGrams)
                    carboEnergy = carboInitInGrams;
                if (carboEnergy < carboProtectedInGrams) {
                    carboEnergy = carboProtectedInGrams;
                    carboAtProtected -= 1;
                }
                else {
                }
                // totalEnergy += (1 / 12) * (kcalCarboPerHour + kcalFatPerHour);
                totalEnergy += frac * (kcalCarboPerHour + kcalFatPerHour);
                // i++;
            }
            return carboData;
        }
        function drawChart(carboData) {
            if (chart.value === null)
                return;
            const carboInit = carboData.carboInit;
            const carboProtected = carboData.carboProtected;
            const energyMax = carboData.totalEnergy[carboData.totalEnergy.length - 1];
            const timeMin = carboData.time[0];
            const timeMid = carboData.time[Math.floor(carboData.time.length / 2)];
            const timeMidLimit = carboData.time[carboData.totalEnergy.length - 1 + Math.floor((carboData.time.length - carboData.totalEnergy.length) / 2)];
            const timeMax = carboData.time[carboData.time.length - 1];
            const displayEnergyDeficit = carboData.totalEnergy.length == carboData.time.length ? false : true;
            const carboEnergy = carboData.carboEnergy.map((value, index) => {
                return { x: carboData.time[index], y: value };
            });
            const totalEnergy = carboData.totalEnergy.map((value, index) => {
                return { x: carboData.time[index], y: value };
            });
            const chartData = {
                datasets: [
                    {
                        data: carboEnergy,
                        unit: 'g',
                        label: ___({
                            en: 'Carbohydrates',
                            de: 'Kohlenhydrate',
                        }),
                        borderColor: '#CDB663',
                        pointRadius: 0,
                        showLine: true,
                        fill: false,
                        yAxisID: 'y',
                    },
                    {
                        data: totalEnergy,
                        unit: 'kcal',
                        label: ___({
                            en: 'Total energy demand',
                            de: 'Gesamtenergiebedarf',
                        }),
                        borderColor: '#636362',
                        pointRadius: 0,
                        showLine: true,
                        fill: false,
                        yAxisID: 'y2',
                    },
                ],
            };
            const chartOptions = {
                normalized: true,
                parsing: false,
                maintainAspectRatio: false,
                responsive: true,
                animation: false,
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            unit: 'hour',
                            tooltipFormat: 'H:mm',
                            displayFormats: {
                                hour: 'HH:mm',
                            },
                        },
                        title: {
                            display: true,
                            text: ___({
                                en: 'Time [hh:mm]',
                                de: 'Zeit [hh:mm]',
                            }),
                        },
                        ticks: {
                            autoSkip: true,
                        },
                    },
                    y: {
                        type: 'linear',
                        position: 'left',
                        title: {
                            display: true,
                            text: ___({
                                en: 'Carbohydrates [g]',
                                de: 'Kohlenhydrate [g]',
                            }),
                        },
                        min: 0,
                        max: Math.ceil(carboInit / 50) * 50,
                        ticks: {
                            autoSkip: true,
                        },
                        grid: {
                            drawOnChartArea: false,
                        },
                    },
                    y2: {
                        type: 'linear',
                        position: 'right',
                        title: {
                            display: true,
                            text: ___({
                                en: 'Energy demand [kcal]',
                                de: 'Energiebedarf [kcal]',
                            }),
                        },
                        min: 0,
                        max: Math.floor(energyMax / 100) * 100,
                        ticks: {
                            autoSkip: true,
                        },
                        grid: {
                            drawOnChartArea: false,
                        },
                    },
                },
                interaction: {
                    mode: 'nearest',
                    axis: 'x',
                    intersect: false,
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            title: (context) => {
                                return ___({
                                    en: 'After ' + context[0].label + 'h:',
                                    de: 'Nach ' + context[0].label + 'h:',
                                });
                            },
                            label: (context) => {
                                return context.dataset.label + ': ' + toFixedNumberStrWithFallback(context.raw.y, 0) + context.dataset.unit;
                            },
                            labelColor: (context) => {
                                return {
                                    borderColor: 'rgba(0, 0, 0, 0)',
                                    backgroundColor: context.dataset.borderColor ?? 'rgba(0, 0, 0, 0)',
                                    borderWidth: 0,
                                };
                            },
                        },
                    },
                    annotation: {
                        common: {
                            drawTime: 'beforeDatasetsDraw',
                        },
                        annotations: [
                            {
                                // [0] box/background - protected carbohydrate reserves
                                type: 'box',
                                id: 'region-1',
                                xScaleID: 'x',
                                yScaleID: 'y',
                                xMin: timeMin,
                                xMax: timeMax,
                                yMin: 0,
                                yMax: carboProtected,
                                backgroundColor: (context) => {
                                    const chartt = context.chart;
                                    const { ctx, chartArea } = chartt;
                                    const carboInitt = carboData.carboInit;
                                    const carboProtectedd = carboData.carboProtected;
                                    let deltaY = chartArea.bottom - chartArea.top;
                                    let rangeTop = Math.ceil(chartArea.top + ((Math.ceil(carboInitt / 50) * 50 - carboProtectedd) / (Math.ceil(carboInitt / 50) * 50)) * deltaY);
                                    let rangeBottom = chartArea.bottom - (chartArea.bottom - rangeTop) * 0.5;
                                    if (!chartArea) {
                                        return 'rgba(99, 99, 98, 0.0)';
                                    }
                                    var gradient = ctx.createLinearGradient(0, rangeBottom, 0, rangeTop);
                                    gradient.addColorStop(0, 'rgba(99, 99, 98, 0.2)');
                                    gradient.addColorStop(1, 'rgba(99, 99, 98, 0.0)');
                                    return gradient;
                                },
                                borderDash: [4, 4],
                                borderDashOffset: 5,
                                borderWidth: 0,
                            },
                            {
                                // [1] text - protected carbohydrate reserves
                                id: 'hline-1',
                                type: 'line',
                                xScaleID: 'x',
                                yScaleID: 'y',
                                value: 0,
                                endValue: carboProtected,
                                xMin: timeMid,
                                xMax: timeMid,
                                yMin: 0,
                                yMax: carboProtected,
                                borderColor: 'transparent',
                                borderWidth: 0,
                                label: {
                                    backgroundColor: 'transparent',
                                    color: '#343a40',
                                    content: ___({
                                        en: 'protected carbohydrate reserves',
                                        de: 'geschützte Kohlenhydrat-Speicher',
                                    }),
                                    display: true,
                                },
                            },
                            {
                                // [2] box/background - energy deficit
                                type: 'box',
                                id: 'region-2',
                                display: displayEnergyDeficit,
                                xScaleID: 'x',
                                yScaleID: 'y',
                                xMin: carboData.time[carboData.totalEnergy.length - 1 - 1],
                                xMax: carboData.time[carboData.totalEnergy.length - 1 + 1],
                                yMin: carboProtected,
                                yMax: Math.ceil(carboInit / 50) * 50,
                                backgroundColor: (context) => {
                                    const chart = context.chart;
                                    const { ctx, chartArea } = chart;
                                    let deltaX = chartArea.width / (carboData.time.length - 1);
                                    let x0 = chartArea.left + (carboData.totalEnergy.length - 1 - 1) * deltaX;
                                    let x1 = chartArea.left + (carboData.totalEnergy.length - 1 + 1) * deltaX;
                                    var gradient = ctx.createLinearGradient(x0, 0, x1, 0);
                                    gradient.addColorStop(0, 'rgba(255, 0, 0, 0.0)');
                                    gradient.addColorStop(1, 'rgba(255, 0, 0, 0.1)');
                                    return gradient;
                                },
                                borderDash: [4, 4],
                                borderDashOffset: 5,
                                borderWidth: 0,
                            },
                            {
                                // [3] box/background - ???
                                type: 'box',
                                id: 'region-3',
                                display: displayEnergyDeficit,
                                xScaleID: 'x',
                                yScaleID: 'y',
                                xMin: carboData.time[carboData.totalEnergy.length - 1 + 1],
                                xMax: timeMax,
                                yMin: carboProtected,
                                yMax: Math.ceil(carboInit / 50) * 50,
                                backgroundColor: 'rgba(255, 0, 0, 0.1)',
                                borderDash: [4, 4],
                                borderDashOffset: 5,
                                borderWidth: 0,
                            },
                            {
                                // [4] text - energy deficit
                                id: 'hline-2',
                                display: displayEnergyDeficit,
                                type: 'line',
                                xScaleID: 'x',
                                yScaleID: 'y',
                                value: 0,
                                endValue: carboProtected,
                                xMin: timeMidLimit,
                                xMax: timeMidLimit,
                                yMin: carboProtected,
                                yMax: Math.ceil(carboInit / 50) * 50,
                                borderColor: 'transparent',
                                borderWidth: 0,
                                label: {
                                    backgroundColor: 'transparent',
                                    color: '#343a40',
                                    content: ___({
                                        en: ['Energy deficit:', ' power can not', 'be maintained'],
                                        de: ['Energiedefizit:', 'Leistung kann nicht', 'aufrechterhalten werden'],
                                    }),
                                    display: true,
                                },
                            },
                        ],
                    },
                },
            };
            if (chartObj === undefined) {
                chartObj = new Chart(chart.value, {
                    type: 'line',
                    data: chartData,
                    options: chartOptions,
                });
                showPlaceholder.value = false;
            }
            else {
                chartObj.data = chartData;
                chartObj.options = chartOptions;
                chartObj.update();
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(___)({
                                    en: 'Carbohydrate Manager',
                                    de: 'Kohlenhydrat Manager',
                                })), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(LabeledSelect, {
                                    class: "mb-6",
                                    title: _unref(___)({ en: 'Carbohydrate-Availability', de: 'Kohlenhydrat-Verfügbarkeit' }),
                                    help: _unref(___)({
                                        en: 'Carbohydrate availability according to the diet and load of the previous days.',
                                        de: 'Kohlenhydrat-Verfügbarkeit entsprechend der Ernährung und Belastung der vergangenen Tage.',
                                    }),
                                    value: carboAvailability.value,
                                    "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((carboAvailability).value = $event)),
                                    options: carboAvailabilityOptions,
                                    "empty-option": emptyCarboAvailabilityOption,
                                    disabled: __props.formDisabled
                                }, null, 8 /* PROPS */, ["title", "help", "value", "disabled"]),
                                _createVNode(LabeledSlider, {
                                    class: "mb-6",
                                    value: carboIntakeTotal.value,
                                    "onUpdate:value": _cache[1] || (_cache[1] = ($event) => ((carboIntakeTotal).value = $event)),
                                    title: _unref(___)({
                                        en: 'Carbohydrate intake',
                                        de: 'Kohlenhydrat Aufnahme',
                                    }),
                                    help: _unref(___)({
                                        en: 'Carbohydrate intake',
                                        de: 'Kohlenhydrat Aufnahme',
                                    }),
                                    unit: "g/h",
                                    min: 0,
                                    max: 120,
                                    step: 1,
                                    disabled: __props.formDisabled
                                }, null, 8 /* PROPS */, ["value", "title", "help", "disabled"]),
                                _createVNode(LabeledSlider, {
                                    class: "",
                                    value: power.value,
                                    "onUpdate:value": _cache[2] || (_cache[2] = ($event) => ((power).value = $event)),
                                    title: _unref(___)({ en: 'Power', de: 'Leistung' }),
                                    help: _unref(___)({
                                        en: 'Power is limited to the anaerobic threshold, as carbohydrate consumption can no longer be determined at a higher energy consumption and other factors limit the power output.',
                                        de: 'Die Leistung ist durch anaeroben Schwelle limitiert, da der Kohlenhydratverbrauch bei einem höheren Energieverbrauch nicht mehr ermittelt werden kann und andere Faktoren leistungslimitierend sind.',
                                    }),
                                    unit: "W",
                                    min: carboLimitMin.value,
                                    max: carboLimitMax.value,
                                    step: 1,
                                    disabled: __props.formDisabled
                                }, null, 8 /* PROPS */, ["value", "title", "help", "min", "max", "disabled"])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(___)({
                                    en: 'Carbohydrate Metrics',
                                    de: 'Kohlenhydrat Metriken',
                                })), 1 /* TEXT */)
                            ]),
                            _createElementVNode("ul", _hoisted_11, [
                                _createElementVNode("li", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(___)({ en: 'Available carbohydrates', de: 'Verfügbare Kohlenhydrate' })), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(_unref(toFixedNumberStrWithFallback)(carboData.value?.carboAvailable, 0))
                                        }, null, 8 /* PROPS */, _hoisted_15),
                                        _cache[4] || (_cache[4] = _createTextVNode(" g", -1 /* CACHED */))
                                    ])
                                ]),
                                _createElementVNode("li", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(___)({ en: 'Time until lack of energy', de: 'Zeit bis Energiemangel' })), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_18, [
                                        (carboData.value === undefined)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "- h"))
                                            : (carboData.value.carboDeficit >= 0.0)
                                                ? (_openBlock(), _createElementBlock("span", {
                                                    key: 1,
                                                    textContent: _toDisplayString(`${carboData.value.carboAvailableTime} h`)
                                                }, null, 8 /* PROPS */, _hoisted_20))
                                                : (carboData.value.carboDeficit < 0.0)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(___)({ en: 'infinite', de: 'unendlich' })), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                    ])
                                ]),
                                _createElementVNode("li", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(___)({ en: 'Relative carbohydrate intake', de: 'Relative Kohlenhydrat-Aufnahme' })), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(_unref(toFixedNumberStrWithFallback)(carboData.value?.carboIntake, 1))
                                        }, null, 8 /* PROPS */, _hoisted_25),
                                        _cache[5] || (_cache[5] = _createTextVNode(" g/kg/h", -1 /* CACHED */))
                                    ])
                                ]),
                                _createElementVNode("li", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(___)({ en: 'Carbohydrate demand', de: 'Kohlenhydrat Bedarf' })), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(_unref(toFixedNumberStrWithFallback)(carboData.value?.carboDemand, 0))
                                        }, null, 8 /* PROPS */, _hoisted_29),
                                        _cache[6] || (_cache[6] = _createTextVNode(" g/h", -1 /* CACHED */))
                                    ])
                                ]),
                                _createElementVNode("li", _hoisted_30, [
                                    (carboData.value === undefined || carboData.value.carboDeficit >= 0.0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(___)({
                                            en: 'Carbohydrate deficit',
                                            de: 'Kohlenhydrat Defizit',
                                        })), 1 /* TEXT */))
                                        : (carboData.value.carboDeficit < 0.0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_unref(___)({
                                                en: 'Carbohydrate excess',
                                                de: 'Kohlenhydrat Überschuss',
                                            })), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                    _createElementVNode("div", _hoisted_33, [
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(_unref(toFixedNumberStrWithFallback)(carboData.value?.carboDeficitAbs, 0))
                                        }, null, 8 /* PROPS */, _hoisted_34),
                                        _cache[7] || (_cache[7] = _createTextVNode(" g/h", -1 /* CACHED */))
                                    ])
                                ]),
                                (__props.hint)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                                        _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(___)({
                                            en: 'Note:',
                                            de: 'Hinweis:',
                                        })), 1 /* TEXT */),
                                        _createTextVNode(" " + _toDisplayString(_unref(___)({
                                            en: 'The determined values are based on physiological assumptions and the individual performance evaluation. Carbohydrate availability, consumption and the potential duration of the effort are subject to many influences and may deviate in practice.',
                                            de: 'Die ermittelten Werte basieren auf physiologischen Annahmen und der individuellen Performance-Auswertung. Kohlenhydrat-Verfügbarkeit, -Verbrauch sowie die mögliche Belastungsdauer unterliegen vielen Einflüssen und können in der Praxis abweichen.',
                                        })) + " " + _toDisplayString(_unref(___)({
                                            en: 'Use the',
                                            de: 'Nutze den',
                                        })) + " ", 1 /* TEXT */),
                                        _createElementVNode("a", {
                                            href: _unref(___)({ en: '/en/about-the-simulator', de: '/de/ueber-den-simulator' }),
                                            class: "link-primary",
                                            target: "_blank",
                                            rel: "noopener noreferrer"
                                        }, _toDisplayString(_unref(___)({ en: 'Ride Simulator', de: 'Ride Simulator' })), 9 /* TEXT, PROPS */, _hoisted_37),
                                        _createTextVNode(" " + _toDisplayString(_unref(___)({
                                            en: 'for detailled nutrition planning and simulation.',
                                            de: 'zur detaillierten Ernährungsplanung und -simulation.'
                                        })), 1 /* TEXT */)
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(___)({
                            en: 'Carbohydrate Stores and Pacing',
                            de: 'Kohlenhydratspeicher und Pacing',
                        })), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", {
                            class: "absolute inset-0",
                            ref_key: "containerRef",
                            ref: containerRef
                        }, [
                            _createElementVNode("canvas", {
                                class: "w-full h-full",
                                ref_key: "chart",
                                ref: chart
                            }, null, 512 /* NEED_PATCH */)
                        ], 512 /* NEED_PATCH */),
                        (showPlaceholder.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _createElementVNode("div", null, [
                                    _cache[3] || (_setBlockTracking(-1, true),
                                        (_cache[3] = _createVNode(SvgVue, {
                                            class: "w-4 h-4",
                                            icon: "lucide/chart-line"
                                        })).cacheIndex = 3,
                                        _setBlockTracking(1),
                                        _cache[3]),
                                    _createTextVNode(" " + _toDisplayString(_unref(___)({ en: 'loading...', de: 'lädt...' })), 1 /* TEXT */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ]));
        };
    }
});
